class FlavorForm extends HTMLElement {
    constructor() {
        super();

        this.querySelectorAll("[data-filter-flavor]").forEach(
            (item) => {
                item.addEventListener("click", this.toggleFlavor.bind(this));
                console.log("click");
            }
        );

        this.querySelectorAll("[data-filter-details]").forEach(
            (item) => {
                item.addEventListener("click", this.toggleDetails.bind(this));
                console.log("click");
            }
        );


    }

    toggleDetails(event) {

        this.querySelectorAll("[data-filter-details]").forEach(
            (item) => {
                item.classList.remove("actif");
            }
        );

        this.querySelectorAll(".product-pack__details").forEach((item) => {
            item.classList.add("hidden");
        });

        let tag = event.currentTarget.dataset.filterDetails;

        event.currentTarget.classList.add("actif");

        this.querySelectorAll(
            `.product-pack__details[data-flavor-tag="${tag}"]`
        ).forEach((item) => {
            item.classList.remove("hidden");
        });

        //   si window.innerWidth est superieur a 990 px calcule si product-pack__details:not(hiddden)  doit avoir un overflow scroll 

        if (window.innerWidth > 990) {
            let detaiheight = document.querySelector(".product-pack__details:not(.hidden) .product-pack__details-container").offsetHeight;
            console.log(detaiheight);

            if (detaiheight < 344) {
                document.querySelector(".product-pack__bottom-content").classList.add("hidden");
                document.querySelector('.flavor-details-container').classList.add("border-bottom");
            } else {
                document.querySelector(".product-pack__bottom-content").classList.remove("hidden");
                document.querySelector('.flavor-details-container').classList.remove("border-bottom");
            }
        }
        document.querySelector('.product-pack__bottom-content span').textContent = tag;

    }

    toggleFlavor(event) {
        this.querySelectorAll("[data-filter-flavor]").forEach(
            (item) => {
                item.classList.remove("actif");
            }
        );

        this.querySelectorAll(".product-pack__flavor").forEach((item) => {
            item.classList.add("hidden");
        });

        let tag = event.currentTarget.dataset.filterFlavor;
        event.currentTarget.classList.add("actif");
        if (tag === "all") {
            this.querySelectorAll(".product-pack__flavor[data-flavor-tag]").forEach((item) => {
                item.classList.remove("hidden");
            });
            event.currentTarget.classList.add("actif");
            return;
        }
        this.querySelectorAll(
            `.product-pack__flavor[data-flavor-tag="${tag}"]`
        ).forEach((item) => {
            item.classList.remove("hidden");
        });
    }
}

customElements.define('flavor-form', FlavorForm);